import React, { ComponentProps } from "react";

export default function LockIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7434 9.64644H8.27789V7.20745C8.27789 6.18091 8.6966 5.24701 9.37386 4.57167C10.0512 3.89437 10.9831 3.47374 12.0097 3.47374C13.0362 3.47374 13.9701 3.89441 14.6455 4.57167C15.3227 5.24701 15.7434 6.18095 15.7434 7.20745V9.64644ZM18.9252 10.1597C18.7284 9.96483 18.4872 9.8143 18.2171 9.72941V7.20745C18.2171 5.49977 17.5186 3.94646 16.3936 2.82153C15.2687 1.6966 13.7173 1 12.0097 1C10.302 1 8.75061 1.6966 7.62568 2.82153C6.50074 3.94646 5.80223 5.49977 5.80223 7.20745V9.7217C5.52438 9.80659 5.27546 9.959 5.07479 10.1597C4.75835 10.4781 4.56152 10.9142 4.56152 11.3965V19.2499C4.56152 19.7323 4.75835 20.1684 5.07479 20.4867C5.39315 20.8032 5.82928 21 6.31162 21H17.6884C18.1708 21 18.6069 20.8032 18.9252 20.4867C19.2417 20.1684 19.4385 19.7323 19.4385 19.2499V11.3965C19.4385 10.9141 19.2417 10.4781 18.9252 10.1597ZM10.7882 13.4226C11.0989 13.1139 11.5273 12.9209 12 12.9209C12.4728 12.9209 12.9011 13.1139 13.2118 13.4226C13.5225 13.7333 13.7135 14.1617 13.7135 14.6344C13.7135 15.0029 13.5977 15.3425 13.4009 15.6223C13.2368 15.8539 13.0169 16.043 12.7602 16.1704V16.9654C12.7602 17.1737 12.6754 17.3648 12.5364 17.5018C12.3994 17.6387 12.2103 17.7256 12 17.7256C11.7916 17.7256 11.6006 17.6387 11.4635 17.5018C11.3265 17.3648 11.2397 17.1737 11.2397 16.9654V16.1704C10.985 16.043 10.765 15.8539 10.601 15.6223C10.4022 15.3426 10.2865 15.003 10.2865 14.6344C10.2865 14.1616 10.4795 13.7333 10.7882 13.4226Z"
        fill="white"
      />
    </svg>
  );
}
